export const GET_MASTER_OPTIONS = 'GET_MASTER_OPTIONS';
export const GET_MASTER_ALL_OPTIONS = 'GET_MASTER_ALL_OPTIONS';
export const MASTER_OPTIONS_REQUEST = 'MASTER_OPTIONS_REQUEST';
export const MASTER_OPTIONS_REQUEST_FAILURE = 'MASTER_OPTIONS_REQUEST_FAILURE';
export const SET_ADD_MASTER_IN_OPTIONS = 'SET_ADD_MASTER_IN_OPTIONS';
export const SET_UPDATE_MASTER_IN_OPTIONS = 'SET_UPDATE_MASTER_IN_OPTIONS';
export const SET_ACCOUNTS_DATA_IN_OPTIONS = 'SET_ACCOUNTS_DATA_IN_OPTIONS';
export const SET_RELOAD_MASTER_PAYLOAD = 'SET_RELOAD_MASTER_PAYLOAD';